const awsconfig = {
  aws_appsync_graphqlEndpoint: process.env.REACT_APP_API_HOST,
  aws_appsync_region: "us-east-1",
};
export default awsconfig;
